import { useGeographySearch } from "./geography/useGeographySearch";
import { useGetOneGeography } from "./geography/useGetOneGeography";

export {
    GeographySchema,
    GeographyArraySchema,
    formatGeographyLabel,
    looksLikeGeographyCode,
    mergeGeographyOptions,
    resolveGeographyOption,
    type Geography,
} from "./geography/geographySchema";

type SearchOptions = {
    nameQuery?: string;
    enabled?: boolean;
};

type ByCodeOptions = {
    enabled?: boolean;
};

/** @deprecated Prefer `useGeographySearch` from `src/api/sure-api/geography/useGeographySearch`. */
export const useSearchGeographies = ({ nameQuery, enabled = true }: SearchOptions = {}) => {
    const { geographies, ...rest } = useGeographySearch({
        searchText: nameQuery,
        enabled,
    });

    return {
        geographies,
        ...rest,
    };
};

/** @deprecated Prefer `useGetOneGeography` from `src/api/sure-api/geography/useGetOneGeography`. */
export const useGeographyByCode = (code: string | null | undefined, options: ByCodeOptions = {}) => {
    const { geography, ...rest } = useGetOneGeography(code, options);

    return {
        geography: geography ?? null,
        ...rest,
    };
};
